import "./index.css";
import React from "react";
import ReactDOM from "react-dom";

import App from "App";
import reportWebVitals from "reportWebVitals";
import setUpTagManager from "setUpTagManager";

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// Google Tag Managerの設定
setUpTagManager();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
